module.exports = __webpack_public_path__ + "img/cover-minigame-bg.65016da0.jpg";